import { Routes, Route, Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import AdminLayout from './components/AdminLayout';
import Dashboard from './pages/Dashboard';
import MatchList from './pages/matches/MatchList';
import MatchForm from './pages/matches/MatchForm';
import TeamList from './pages/teams/TeamList';
import TeamForm from './pages/teams/TeamForm';
import PlayerList from './pages/players/PlayerList';
import PlayerForm from './pages/players/PlayerForm';
import LoginPage from './pages/LoginPage';
import LeagueList from './pages/leagues/LeagueList';
import LeagueForm from './pages/leagues/LeagueForm';
import TeamRoster from './pages/teams/TeamRoster';
import SettleMatch from './pages/matches/SettleMatch';
import PlayerDetails from './pages/players/PlayerDetails';
import TeamDetails from './pages/teams/TeamDetails';
import AdminMatchDetails from './pages/matches/AdminMatchDetails';
import '../styles/AdminPanel.css';

const AdminPanel = () => {
  const { isAuthenticated, isLoading } = useAuth();

  // Show loading spinner while checking authentication
  if (isLoading) {
    return <div className="spinner"></div>;
  }

  // If not authenticated, redirect to login
  if (!isAuthenticated) {
    return <LoginPage />;
  }

  // If authenticated, show admin panel
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/matches" element={<MatchList />} />
        <Route path="/matches/create" element={<MatchForm />} />
        <Route path="/matches/edit/:id/:date" element={<MatchForm />} />
        {/*<Route path="/matches/settle/:id/:date" element={<MatchForm />} />*/}
        <Route path="/matches/settle/:id/:date" element={<SettleMatch />} />
        <Route path="/teams" element={<TeamList />} />
        <Route path="/teams/create" element={<TeamForm />} />
        <Route path="/teams/edit/:id" element={<TeamForm />} />
        <Route path="/teams/:id" element={<TeamDetails />} />
        <Route path="/players" element={<PlayerList />} />
        <Route path="/players/create" element={<PlayerForm />} />
        <Route path="/players/edit/:id" element={<PlayerForm />} />
        <Route path="/players/:id" element={<PlayerDetails />} />
        <Route path="/leagues" element={<LeagueList />} />
        <Route path="/leagues/create" element={<LeagueForm />} />
        <Route path="/leagues/edit/:id" element={<LeagueForm />} />
        <Route path="/teams/roster/:id" element={<TeamRoster />} />
        <Route path="/matches/:id/:date" element={<AdminMatchDetails />} />
        {/* Redirect any other paths to dashboard */}
        <Route path="*" element={<Navigate to="/" replace />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminPanel;
